import React from 'react'
import {NavLink, useNavigate} from 'react-router-dom'
import {useEyeconxStore} from '../../../store/eyeconxStore'

function SmsSide() {
    const logout = useEyeconxStore(state => state.logout)
    const smsInbox = useEyeconxStore(state => state.smsInbox)
    const navigate = useNavigate()

    const handleLogout = () => {
        logout()
        navigate('/login')
    }

    return (
        <div className='d-flex flex-column flex-shrink-0 p-1 bg-white shadow-sm'
             style={{width: "250px", height: "100vh", borderRight: "1px solid rgba(0,0,0,0.1)"}}>
            {/* Logo */}
            <div className='d-flex justify-content-center align-items-center mb-4 mt-2'>
                <img
                    src="media/logos2/neweyeconxlogo.png"
                    style={{maxWidth: "180px"}}
                    alt="EyeconX"
                    className="img-fluid"
                />
            </div>
            <hr/>
            {/* Navigation */}
            <ul className='nav nav-pills flex-column mb-auto mt-1 gap-1 ms-2 me-2'>
                <li className='nav-item'>
                    <NavLink
                        to={'sms-dashboard'}
                        className={({isActive}) =>
                            `nav-link rounded-3 d-flex align-items-center py-2 px-2 ${isActive ?
                                'bg-primary bg-opacity-10 text-primary fw-medium' :
                                'text-dark hover-bg-light'}`
                        }
                    >
                        <i className="bi bi-speedometer2 fs-5 me-3"></i>
                        <span>Dashboard</span>
                    </NavLink>
                </li>

                <li className='nav-item'>
                    <NavLink
                        to={'sms-messages'}
                        className={({isActive}) =>
                            `nav-link rounded-3 d-flex align-items-center justify-content-between py-3 px-3 ${isActive ?
                                'bg-success bg-opacity-10 text-success fw-medium' :
                                'text-dark hover-bg-light'}`
                        }
                    >
                        <div className="d-flex align-items-center">
                            <i className="bi bi-chat-left-text fs-5 me-3"></i>
                            <span>Messages</span>
                        </div>
                        {smsInbox > 0 && (
                            <span className="badge rounded-pill bg-success" style={{fontSize: "0.65rem"}}>
                {smsInbox}
              </span>
                        )}
                    </NavLink>
                </li>

                <li className='nav-item'>
                    <NavLink
                        to={'sms-clinic-settings'}
                        className={({isActive}) =>
                            `nav-link rounded-3 d-flex align-items-center py-3 px-3 ${isActive ?
                                'bg-info bg-opacity-10 text-info fw-medium' :
                                'text-dark hover-bg-light'}`
                        }
                    >
                        <i className="bi bi-gear fs-5 me-3"></i>
                        <span>Settings</span>
                    </NavLink>
                </li>
            </ul>

            {/* Logout */}

            <div className='mt-auto'>
                <hr/>
                <button
                    onClick={handleLogout}
                    className='btn btn-outline-danger w-100 py-2 d-flex align-items-center justify-content-center'
                    style={{transition: "all 0.2s"}}
                >
                    <span>Logout</span>
                    <i className="bi bi-box-arrow-right ms-2"></i>
                </button>

                <div className='text-muted text-center mt-3'>
                    <small className='text-muted'>
                        {new Date().getFullYear()} &copy; EyeconX. All rights reserved
                    </small>
                </div>
            </div>
        </div>
    )
}

export default SmsSide